import { DismissSuggestionsDto } from '../core/phone-suggestions';
import { HttpClient } from './http';

export interface PhoneSuggestionsService {
  dismissSuggestions: (dto: DismissSuggestionsDto) => Promise<void>;
}

export function createPhoneSuggestionsService(
  httpClient: HttpClient,
  baseUrl: string,
): PhoneSuggestionsService {
  return {
    dismissSuggestions: (dto: DismissSuggestionsDto) => {
      return httpClient<void>(
        `${baseUrl}/phone-suggestions/dismiss-suggestions`,
        'post',
        { body: dto },
      );
    },
  };
}
